exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.past[data-v-1636283e] {\n  color: #a1a1a1;\n}\n.show-event-info[data-v-1636283e] {\n  color: -moz-default-color;\n}\n", ""]);

// exports
